import { GenericTableHead } from '../common';
import { EnhancedTableHeadProps } from '../ValuationsTable.types';

const ValuationsTableHead = ({
  order,
  orderBy,
  sortCriteria,
  onRequestSort,
  columns,
  columnWidths,
  onColumnWidthChange,
}: EnhancedTableHeadProps) => (
  <GenericTableHead
    order={order}
    orderBy={orderBy}
    sortCriteria={sortCriteria}
    onRequestSort={onRequestSort}
    columns={columns}
    columnWidths={columnWidths}
    onColumnWidthChange={onColumnWidthChange}
  />
);

export default ValuationsTableHead;
